import { MatSnackBarLabel, MatSnackBarActions, MatSnackBarAction, MatSnackBarRef, MAT_SNACK_BAR_DATA } from "@angular/material/snack-bar";
import { MatButtonModule } from "@angular/material/button";
import { Component, Inject, inject } from "@angular/core";

@Component({
    selector: 'lib-snack-message',
    template: `
    <span matSnackBarLabel>
        {{ message }}
    </span>
    <span matSnackBarActions>
        <button mat-button matSnackBarAction (click)="snackBarRef.dismissWithAction()"
        >{{closeText}}</button>
    </span>
  `,
    styles: `
      :host {
        display: flex;
      }
    `,
    standalone: true,
    imports: [MatButtonModule, MatSnackBarLabel, MatSnackBarActions, MatSnackBarAction],
})
export class SnackMessageComponent {

    public snackBarRef = inject(MatSnackBarRef);
    public message = '';
    public closeText = '';


    constructor(@Inject(MAT_SNACK_BAR_DATA) public data: {
        message: string,
        closeText: string
    }) {
        this.message = data.message;
        this.closeText = data.closeText || 'Close';
    }
}
